import { motion } from 'framer-motion';
import { Typography, ListItemButton } from '@mui/material';
import CheckY from '../../../Assets/Images/CheckY.png';
import CheckN from '../../../Assets/Images/CheckN.png';
import PerButton from './PerButton';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useSelector } from 'react-redux';

export default function TypeWork({ form, setInput, codeList, SearchLogic2 }) {
  const activeStep = useSelector((state) => state.common.activeStep);
  const dispatch = useDispatch();

  return (
    <div>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.3,
        }}
      >
        <p>먼저 작업 종류를 선택할게요.</p>
        <p style={{ fontSize: '16px', color: '#939393' }}>
          1개 이상 선택해주세요.
        </p>
        <div style={{ marginBottom: '16px' }}>
          {codeList && codeList.length > 0 ? (
            codeList.map((item, index) => (
              <ListItemButton
                key={index}
                sx={{
                  mt: 1.25,
                  p: 2,
                  py: 1.5,
                  gap: 1,
                  border: 1,
                  borderRadius: 2.5,
                  borderColor: form.WORK_TYPE?.includes(item.code)
                    ? '#80CB66'
                    : '#E8E8E8',
                  backgroundColor: form.WORK_TYPE?.includes(item.code)
                    ? '#ECF6E8'
                    : '#fff',
                  '&:focus': {
                    outline: 'none',
                    borderColor: form.WORK_TYPE?.includes(item.code)
                      ? '#80CB66'
                      : '#E8E8E8',
                    backgroundColor: form.WORK_TYPE?.includes(item.code)
                      ? '#ECF6E8'
                      : '#fff',
                  },
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => {
                  setInput((prev) => {
                    const selected = prev.WORK_TYPE ?? [];
                    const selectedArr = Array.isArray(selected)
                      ? selected
                      : [selected].filter(Boolean);

                    if (selectedArr.includes(item.code)) {
                      const next = {
                        ...prev,
                        WORK_TYPE: selectedArr?.filter(
                          (code) => code !== item.code
                        ),
                      };

                      return next;
                    } else {
                      const next = {
                        ...prev,
                        WORK_TYPE: [...selectedArr, item.code],
                      };

                      return next;
                    }
                  });
                }}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {item.codeNm}
                </Typography>
                <img
                  src={form.WORK_TYPE?.includes(item.code) ? CheckY : CheckN}
                  alt="체크"
                />
              </ListItemButton>
            ))
          ) : (
            <div
              style={{ textAlign: 'center', padding: '20px', color: '#939393' }}
            >
              작업 종류를 불러오는 중...
            </div>
          )}
        </div>

        {/* 버튼 */}
        <PerButton
          cancelText={'이전'}
          onCancel={() => {
            dispatch(CommonActions.setActiveStep(activeStep - 1));
          }}
          onClick={(e) => {
            if (!form.WORK_TYPE || form.WORK_TYPE.length === 0) {
              dispatch(
                showSnackbar({
                  message: '작업 종류를 선택해주세요.',
                  type: 'warning',
                })
              );
              return;
            }
            dispatch(CommonActions.increaseStep());
            SearchLogic2();
          }}
        />
      </motion.div>
    </div>
  );
}
